// About.jsx

import React, { useState, useRef } from "react";
import "./WorksGallery.css";
import { Link } from "react-router-dom";


export default function WorksGalleryPage() {
 const images = [
    {
      src: "/images/1.jpg",
      title: "איטום חדרים רטובים",
  
    },
    {
      src: "/images/2.jpg",
      title: "איטום גגות ביריעות ",
  
    },
    {
      src: "/images/3.jpg",
      title: " איטום גגות במרכז",
   
    },
    {
      src: "/images/4.jpg",
      title: "איטום הגג",
   
    },
    {
      src: "/images/5.jpg",
      title: "עבודות גובה",
    },
    {
      src: "/images/6.jpg",
      title: "איטום חדרים ",
    },
        {
      src: "/images/7.jpg",
      title: "עבודה בגבהים ",
  
    },
    {
      src: "/images/8.jpg",
      title: "תיקון גגות",
  
    },
    {
      src: "/images/9.jpg",
      title: "איטום גגות לפני ואחרי  ",
   
    },
    {
      src: "/images/10.jpg",
      title: "יריעות ביטומניות",
   
    },
    {
      src: "/images/11.jpg",
      title: "איטום לפני ואחרי",
    },
    {
      src: "/images/12.jpg",
      title: "  ",
    },
        {
      src: "/images/13.jpg",
      title: "  ",
  
    },
    {
      src: "/images/14.jpg",
      title: "עבודות סנפלינג",
  
    },
    {
      src: "/images/15.jpg",
      title: "  ",
   
    },
    {
      src: "/images/16.jpg",
      title: " איטום גגות במרכז",
   
    },
    {
      src: "/images/17.jpg",
      title: "תיקון יריעות ביטומניות ",
    },
    {
      src: "/images/18.jpg",
      title: "איטום הגג ביריעות ביטומניות  ",
    },
        {
      src: "/images/19.jpg",
      title: "  ",
  
    },
    {
      src: "/images/20.jpg",
      title: " ",
  
    },
    {
      src: "/images/21.jpg",
      title: "תיקוני גגות  ",
   
    },
    {
      src: "/images/22.jpg",
      title: " ",
   
    },
    {
      src: "/images/23.jpg",
      title: " ",
    },
    {
      src: "/images/24.jpg",
      title: "  ",
    },
        {
      src: "/images/25.jpg",
      title: "  ",
    },
        {
      src: "/images/26.jpg",
      title: "  ",
    },
        {
      src: "/images/27.jpg",
      title: "  ",
    },
        {
      src: "/images/28.jpg",
      title: "  ",
    },
        {
      src: "/images/29.jpg",
      title: "  ",
    },
        {
      src: "/images/30.jpg",
      title: "עבודות בגובה עם איטומים גבוהים",
    },
        {
      src: "/images/31.jpg",
      title: "  ",
    },
        {
      src: "/images/32.jpg",
      title: "  ",
    },
        {
      src: "/images/33.jpg",
      title: "  ",
    },
        {
      src: "/images/34.jpg",
      title: "  איטומי גגות",
    },
  ];

 const [currentIndex, setCurrentIndex] = useState(null);
  const [zoom, setZoom] = useState(1);

  const startX = useRef(0);

  const openImage = (index) => {
    setCurrentIndex(index);
    setZoom(1);
  };

  const closeModal = () => {
    setCurrentIndex(null);
    setZoom(1);
  };

  const next = (e) => {
    e?.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % images.length);
    setZoom(1);
  };

  const prev = (e) => {
    e?.stopPropagation();
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
    setZoom(1);
  };

  /* 📱 swipe */
  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const diff = startX.current - e.changedTouches[0].clientX;

    if (Math.abs(diff) > 50) {
      if (diff > 0) next();
      else prev();
    }
  };

  /* 🔍 zoom */
  const handleWheel = (e) => {
    setZoom((prev) => {
      let z = prev + (e.deltaY < 0 ? 0.1 : -0.1);
      return Math.min(Math.max(z, 1), 3);
    });
  };

  const current = currentIndex !== null ? images[currentIndex] : null;

  return (

    <div className="WorksGallery-page">
      <div className="WorksGallery-hero">
        <div className="WorksGallery-overlay">
          <h1> גלריית עבודות</h1>
        </div>

<div>

</div>



</div>
    <div className="page4">
 <div className="breadcrumb4">
  <Link to="/">בית</Link> /{" "}
  <Link to="/WorksGallery"> גלריית עבודות</Link>
</div>
</div>
<div className="page1">



      {/* גלריה */}
    {/* GRID */}
<div className="grid">
  {images.map((img, index) => (
    <div
      key={index}
      className="cardd"
      onClick={() => openImage(index)}
    >
      <img src={img.src} alt="" className="img" />

      <div className="overlay">
        <h3>{img.title}</h3>
      </div>
    </div>
  ))}
</div>

{currentIndex !== null && (
  <div className="modal" onClick={closeModal}>
    
    {/* כפתור סגירה */}
    <button className="close-btn" onClick={closeModal}>
      ✕
    </button>

    <button className="navv left" onClick={prev}>‹</button>
    <button className="navv right" onClick={next}>›</button>

    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
      <img
        src={current.src}
        className="modal-img"
        alt=""
      />

      <div className="modal-text">
        <h2>{current.title}</h2>
      </div>
    </div>

  </div>
)}
    </div>










    </div>





  );
}


